import { z } from 'zod';

/**
 * Shape estándar de error HTTP compartido entre backend y frontend.
 * Inspirado en RFC 7807 (problem+json).
 */
export const ApiErrorSchema = z.object({
  type: z.string().describe('Identificador del tipo de error (URN)'),
  title: z.string().describe('Resumen corto legible'),
  status: z.number().int().min(400).max(599),
  detail: z.string().optional(),
  instance: z.string().optional(),
  /** Errores de validación por campo. */
  errors: z
    .array(
      z.object({
        path: z.string(),
        message: z.string(),
        code: z.string().optional(),
      }),
    )
    .optional(),
  /**
   * FeatureDisabledError extension fields (RFC 7807 §3.2 — additional members).
   * Present only when `type = 'urn:condo:feature-disabled'`.
   */
  feature: z.string().optional(),
  capability: z.string().optional(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

export const ErrorCodes = {
  VALIDATION_FAILED: 'urn:condo:validation-failed',
  UNAUTHORIZED: 'urn:condo:unauthorized',
  FORBIDDEN: 'urn:condo:forbidden',
  FEATURE_DISABLED: 'urn:condo:feature-disabled',
  NOT_FOUND: 'urn:condo:not-found',
  CONFLICT: 'urn:condo:conflict',
  TENANT_MISMATCH: 'urn:condo:tenant-mismatch',
  INTERNAL: 'urn:condo:internal-error',
} as const;
